// exports the routes for the app.
export const routes = {
  landing: "/",
  search: "/search",
};
